import React, { createContext, useMemo, useState } from 'react';
import { IInputsState, InputsContextProps } from '../types';

const INITIAL_STATE: IInputsState = {
  locationDropoff: false,
  datesModal: false,
  timeModal: false, // Mobile only
  timePickup: false,
  timeDropoff: false,
};

export const InputsContext = createContext<InputsContextProps>({
  inputsState: INITIAL_STATE,
  updateInputsState: {} as InputsContextProps['updateInputsState'],
});

const InputsProvider = ({ children }: { children: React.ReactNode }) => {
  const [openInputs, setOpenInputs] = useState<IInputsState>(INITIAL_STATE);

  const updateInputsState: InputsContextProps['updateInputsState'] = {
    openLocationDropoff: () => {
      setOpenInputs({ ...INITIAL_STATE, locationDropoff: true });
    },
    openDates: () => {
      setOpenInputs({ ...INITIAL_STATE, datesModal: true });
    },
    openTimeModal: () => {
      setOpenInputs({ ...INITIAL_STATE, timeModal: true });
    },
    openTimePickup: () => {
      setOpenInputs({ ...INITIAL_STATE, timePickup: true });
    },
    openTimeDropoff: () => {
      setOpenInputs({ ...INITIAL_STATE, timeDropoff: true });
    },
    closeAllInputs: () => {
      setOpenInputs(INITIAL_STATE);
    },
  };

  const props: InputsContextProps = useMemo(() => ({ inputsState: openInputs, updateInputsState }), [openInputs]);

  return <InputsContext.Provider value={props}>{children}</InputsContext.Provider>;
};

export default InputsProvider;
